import React from 'react';
import { Link } from 'react-router-dom'

const Home = () => {

  return (
    <main className='dashboard flex flex-wrap items-center justify-center h-[92vh]'>
      <div className='mx-auto p-4 '>
        <div className="bg-white  rounded-lg ">
          <div className="p-4 space-y-2">
            <h2><b>Buy airtime for Safaricom, Airtel and Telkom</b></h2>
            <p>If you are new here, You can use this portal to purchase airtime and bundles in bulk.</p>
            <p>Buy airtime for Safaricom, Airtel and Telkom</p>
            <p>Buy Safaricom Bundle Data</p>
            <div className='flex flex-wrap items-center gap-4'>
              <Link to="/app/buyairtime" className="border border-black px-6 py-1 rounded-lg hover:text-white hover:bg-[#134463]">Buy Airtime</Link>
              <Link to="/app/buybundle" className="border border-black px-6 py-1 rounded-lg hover:text-white hover:bg-[#134463]">Buy Bundle</Link>
              <Link to="/app/buyviaexcel" className="border border-black px-6 py-1 rounded-lg hover:text-white hover:bg-[#134463]">Buy Via Excel</Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
